/* eslint-disable no-nested-ternary */
import * as _ from 'underscore';
import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import ItemInfoCollection, { LinkType } from '../collection/ItemInfoCollection';
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION, ITEM_MODE_NO } from '../Constants';
import { MarkItemInterface } from './LiDAR/MarkInterface';
import QuotationListCollection from '../collection/QuotationListCollection';
import CalculationUtil from './CalculationUtil';

export default class WebcadJSONParser {
  /**
   * 読込みデータの生成
   * @jsonData JSON 読み込みデータ
   */
  static reproduceWebCAD(jsonData: any, reverse: Boolean = false, isSaveHistory: Boolean = false, deferredObj: Function = null): void {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
    if (jsonData === null || jsonData === '') {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_HOUSE;
      marietta.webcad.WebCADGlobal.itemMenu.initView();
      return;
    }
    // BUSY表示
    marietta.webcad.WebCADGlobal.showBusy('Loading...');
    // プランの読込
    const p = new Promise((resolve: Function) => {
      setTimeout(marietta.webcad.util.WebcadJSONParser.parse, 300, jsonData, reverse, resolve, isSaveHistory);
    });
    // アイテム生成完了後にヒストリに保管
    p.then(async () => {
      // 開いた・元に戻した UB の高さは変えず、今の状態を UB の天井合わせの基準にする
      marietta.webcad.util.UnitBathUtil.resetBaseline();
      if (!isSaveHistory) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
      // 選択モードへ変更
      document.getElementById('checkSelectMode').click();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;
      // UNODO・REDOの場合は階数を変更しない
      if (isSaveHistory !== true) {
        // フロア表示の初期化処理
        marietta.webcad.WebCADGlobal.changeFloor(1);
      }

      // UNDO・REDOは下絵の位置を更新する
      if (isSaveHistory) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateShitaePositionToHistory();
      }

      // 取り込んだピンを別企画（現在の図面）へインポート
      // await marietta.webcad.util.WebcadJSONParser.importPinsFromJsonData(jsonData);

      // deferredObjを返す
      if (deferredObj) {
        deferredObj();
      }
      // 画像検知マーク非表示
      marietta.webcad.WebCADGlobal.webcad2Dmanager.displayMark = false;
    });
  }

  /**
   * 読込んだJSONデータに含まれるピン（pin_id）を、現在編集中の企画へインポートする
   * インポートAPIでエラーや予期せぬ結果になった場合は、対象ピンのbefore/after画像データを破棄する
   * @param jsonData 読込みデータ
   */
  static async importPinsFromJsonData(jsonData: any): Promise<void> {
    let data: any;
    try {
      data = typeof jsonData === 'object' ? jsonData : JSON.parse(jsonData);
    } catch (err) {
      console.error(err);
      return;
    }

    // 読込データに含まれる旧ピンID一覧（重複除去）
    const pinIds: string[] = _.uniq(
      ((data?.plan?.text ?? []) as any[])
        .map((item) => item.pin_id)
        .filter((pinId: string): boolean => !!pinId),
    );
    if (pinIds.length < 1) return;

    // 現在編集中の図面に生成されているピンアイテムを取得
    const pinAry: marietta.webcad.item.PinPicture[] = [];
    for (let i = 1; i <= marietta.webcad.WebCADGlobal.MAX_FLOORS; i += 1) {
      const tarLayer: marietta.webcad.layer.ItemLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(i, ITEM_MODE_NO.MODE_FREETEXT_NO);
      pinAry.push(...<marietta.webcad.item.PinPicture[]>tarLayer.getAllChildren());
    }
    const targetPins = pinAry.filter((pin) => pinIds.includes(pin.itemInfo.pin_id));
    if (targetPins.length < 1) return;

    // インポート先（現在の企画）の企画ID
    const planId = marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id;

    try {
      const res = await marietta.webcad.manager.APIManager.importPins(planId, pinIds);
      if (!res) {
        throw new Error('Pin import failed.');
      }

      targetPins.forEach((pin) => {
        const oldPinId = pin.itemInfo.pin_id;
        const newPinId = res.pin_id_map?.[oldPinId];
        if (newPinId) {
          pin.itemInfo.pin_id = newPinId;
        }
        pin.itemInfo.link = (pin.itemInfo.link ?? []).map((link: LinkType) => ({
          ...link,
          id: (link.id && res.before_image_id_map?.[link.id]) || link.id,
        }));
        pin.itemInfo.after_link = (pin.itemInfo.after_link ?? []).map((link: LinkType) => ({
          ...link,
          id: (link.id && res.after_image_id_map?.[link.id]) || link.id,
        }));
      });
    } catch (err) {
      console.error(err);
      // インポートAPIでエラー・予期せぬ結果になった場合は写真データを破棄する
      targetPins.forEach((pin) => {
        pin.itemInfo.link = [];
        pin.itemInfo.after_link = [];
      });
    }
  }

  /**
   *
   * @param str
   * @returns
   */
  static IsJsonString(str: any) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  /**
     * パースする
     * */
  static parse(datJSON: any, reverse: Boolean = false, deferredObj = null, isSaveHistory: Boolean = false) {
    let jsonData = datJSON;
    const isJson = marietta.webcad.util.WebcadJSONParser.IsJsonString(datJSON);
    if (!isJson) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_HOUSE;
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JSON_IMPORT_FAIL'));
      marietta.webcad.WebCADGlobal.hideBusy();
      marietta.webcad.WebCADGlobal.itemMenu.initView();
      return;
    }
    let data;
    if (typeof jsonData === 'object') {
      data = jsonData;
    } else {
      data = JSON.parse(jsonData);
    }

    if (!data) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_HOUSE;
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_JSON_IMPORT_FAIL'));
      marietta.webcad.WebCADGlobal.hideBusy();
      marietta.webcad.WebCADGlobal.itemMenu.initView();
      return;
    }
    // 20181229 historyから復元している場合は、敷地の保持は実施しない
    let siteInputMode = 0;
    if (!isSaveHistory) {
      const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
      siteInputMode = tarLayer.mode;

      // レイヤー削除前にアイテムを保管
      marietta.webcad.util.WebcadJSONParser.keepSiteItem();
    }

    // レイヤー全体の初期化
    marietta.webcad.WebCADGlobal.layerGroup.initMe();

    marietta.webcad.util.WebcadJSONParser.reproduceApplicationInfo(data.application);

    marietta.webcad.util.WebcadJSONParser.reproducePlanDataInfo(data.plan);

    // 3Dモデル用パラメータの判別と登録処理
    marietta.webcad.util.WebcadJSONParser.reproduceModelParam(data.plan.model_param);

    marietta.webcad.util.WebcadJSONParser.reproduceQuotationData(data.plan.quotation);

    // 敷地
    marietta.webcad.util.WebcadJSONParser.reproduceSiteItem(data.plan.site);

    marietta.webcad.util.WebcadJSONParser.reproduceRoomItem(data.plan.room, reverse);

    // 壁
    marietta.webcad.util.WebcadJSONParser.reproduceWallItem(data.plan.wall);

    // 階段
    marietta.webcad.util.WebcadJSONParser.reproduceStairItem(data.plan.stair, reverse);
    // 建具
    marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(data.plan.fitting, 'fitting', reverse);
    // 住宅設備
    marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(data.plan.equipment, 'equipment', reverse);
    // 家具
    marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(data.plan.furniture, 'furniture', reverse);
    // エクステリア
    marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(data.plan.exterior, 'exterior', reverse);
    // 屋根
    marietta.webcad.util.WebcadJSONParser.reproduceRoofItem(data.plan.roof);

    // テキストアイテム
    marietta.webcad.util.WebcadJSONParser.reproduceFreeTextItem(data.plan.text);

    // 画像検知マーク
    marietta.webcad.util.WebcadJSONParser.reproduceMarkItem(data.plan.mark);

    // 柱
    marietta.webcad.util.WebcadJSONParser.reproduceColumnItem(data.plan.column);

    // 梁
    marietta.webcad.util.WebcadJSONParser.reproduceBeamItem(data.plan.beam);


    // undo/redo以外はFit実行
    if (!isSaveHistory) {
      // 中央に移動
      marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
    }

    // 20181229 historyから復元している場合は、敷地の保持は実施しない
    if (!isSaveHistory) {
      // 敷地があった場合は表示させる
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.siteList != null) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = siteInputMode;
        marietta.webcad.WebCADGlobal.webcad2Dmanager.siteList.forEach((item) => {
          marietta.webcad.WebCADGlobal.itemManager.createItem(item);
        });
      }
    }

    // アクションモードの設定
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updatecurrentActionModeFromItemMenu();

    // 階数の更新
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateFloorSelection();

    // 保持している下絵があれば、再生成
    marietta.webcad.util.WebcadJSONParser.resetShitae();

    // BUSY表示
    setTimeout(marietta.webcad.WebCADGlobal.hideBusy, 300);

    if (deferredObj) deferredObj();
  }

  /**
   *
   * @param datXML
   * @returns
   */
  static webcadXmlToJson(datXML: Element) {
    const retJSON: any = {};
    // retJSON.webcad = {};
    // アプリケーション
    retJSON.application = marietta.webcad.util.WebcadJSONParser.applicationXmlToJson((datXML).querySelector('application'));

    // プラン情報
    retJSON.plan = marietta.webcad.util.WebcadJSONParser.planXmlToJson((datXML).querySelector('plan'));

    // プラン情報
    retJSON.plan.model_param = marietta.webcad.util.WebcadJSONParser.modelParamXmlToJson(datXML.querySelector('plan > model_param'));

    // 敷地
    retJSON.plan.site = marietta.webcad.util.WebcadJSONParser.siteXmlToJson(datXML.querySelector('plan > site'));

    // 間取
    retJSON.plan.room = marietta.webcad.util.WebcadJSONParser.roomXmlToJson((datXML).querySelector('plan > room'));

    // 階段
    retJSON.plan.stair = marietta.webcad.util.WebcadJSONParser.stairXmlToJson((datXML).querySelector('plan > stair'));

    // 建具
    retJSON.plan.fitting = marietta.webcad.util.WebcadJSONParser.commonXmlToJson((datXML).querySelector('plan > fitting'), 'fitting');

    // 住設
    retJSON.plan.equipment = marietta.webcad.util.WebcadJSONParser.commonXmlToJson((datXML).querySelector('plan > equipment'), 'equipment');

    // 家具
    retJSON.plan.furniture = marietta.webcad.util.WebcadJSONParser.commonXmlToJson((datXML).querySelector('plan > furniture'), 'furniture');

    // エクステリア
    retJSON.plan.exterior = marietta.webcad.util.WebcadJSONParser.commonXmlToJson((datXML).querySelector('plan > exterior'), 'exterior');

    // 屋根
    retJSON.plan.roof = marietta.webcad.util.WebcadJSONParser.roofXmlToJson((datXML).querySelector('plan > roof'));

    // テキストアイテム
    retJSON.plan.text = [];

    // 柱
    retJSON.plan.column = [];
    // 梁
    retJSON.plan.beam = [];

    return JSON.stringify(retJSON);
  }

  /**
   *アプリケーションデータxmlをjsonに変換します
   * @param appXml
   * @returns
   */
  static applicationXmlToJson(appXml: any) {
    // 読込プランのバージョン
    let appVersion = '';
    const appName = '';
    const appCustomize = '';
    if ((appXml).querySelector('version') != null) {
      appVersion = appXml.querySelector('version').textContent;
    }
    return {
      name: appName,
      version: appVersion,
      customize: appCustomize,
    };
  }

  /**
   *計画情報データxmlをjsonに変換します
   * @param planXml
   * @returns
   */
  static planXmlToJson(planXml: any) {
    let modulePitch: number = 0;
    let snapUnit: number = 0;
    let buildingType: number = 0;
    // モジュール
    if (planXml.getAttribute('module') != null) {
      modulePitch = parseInt(planXml.getAttribute('module'), 10);
    }
    if (!Number.isNaN(parseFloat(planXml.getAttribute('grid')))) {
      snapUnit = parseFloat(planXml.getAttribute('grid'));
    }
    if (planXml.getAttribute('building_type') != null || planXml.getAttribute('building_type') != null) {
      buildingType = parseInt(planXml.getAttribute('building_type'), 10);
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_HOUSE;
    }

    // 寸法補正（0: フリー寸法 / 1: モジュール補正）。欠落時は null（既定のフリー寸法を維持）
    const dimensionCorrectionAttr: string | null = planXml.getAttribute('dimension_correction');
    const dimensionCorrection: number | null = dimensionCorrectionAttr != null ? parseInt(dimensionCorrectionAttr, 10) : null;

    return {
      module: modulePitch,
      grid: snapUnit,
      building_type: buildingType,
      dimension_correction: dimensionCorrection,
    };
  }

  /**
   *3Dデータxmlをjsonに変換します
   * @param modelParamXml
   * @returns
   */
  static modelParamXmlToJson(modelParamXml: any) {
    if (modelParamXml) {
      const modelParamNode: any = {};
      const optionNode: any = marietta.webcad.util.WebcadJSONParser.optionXmlToJson((modelParamXml).querySelector('option'));
      const heightNode: any = marietta.webcad.util.WebcadJSONParser.heightXmlToJson((modelParamXml).querySelector('height'));
      const autoNode: any = marietta.webcad.util.WebcadJSONParser.autoXmlToJson((modelParamXml).querySelector('auto'));
      const materialNode: any = marietta.webcad.util.WebcadJSONParser.materialXmlToJson((modelParamXml).querySelector('material'));
      modelParamNode.option = optionNode;
      modelParamNode.height = heightNode;
      modelParamNode.auto = autoNode;
      modelParamNode.material = materialNode;
      return modelParamNode;
    }
    return null;
  }

  /**
   * 3D modelParam optionxmlデータをjsonに変換します
   * @param optionXml
   * @returns
   */
  static optionXmlToJson(optionXml: any) {
    let optionNode: any = {};
    const optionData = optionXml;
    if (optionData) {
      const data: marietta3d.AutoGen.Option = marietta.webcad.WebCADGlobal.autoMain.Model.Option;
      optionNode.tuma_kazari = optionData.querySelector('tuma_kazari') ? parseInt(optionData.querySelector('tuma_kazari').textContent, 10) : data.tumaKazari;
      optionNode.flower_box = optionData.querySelectorAll('flower_box') ? parseInt(optionData.querySelector('flower_box').textContent, 10) : data.flowerBox;
      optionNode.desumi_sousyoku = optionData.querySelector('desumi_sousyoku') ? parseInt(optionData.querySelector('desumi_sousyoku').textContent, 10) : data.desumiSousyoku;
      optionNode.yoroido = optionData.querySelector('yoroido') ? parseInt(optionData.querySelector('yoroido').textContent, 10) : data.yoroido;
      optionNode.men_gousi = optionData.querySelector('men_gousi') ? parseInt(optionData.querySelector('men_gousi').textContent, 10) : data.menGousi;
      optionNode.timber = optionData.querySelector('timber') ? parseInt(optionData.querySelector('timber').textContent, 10) : data.timber;
      optionNode.hisasi = optionData.querySelector('hisasi') ? parseInt(optionData.querySelector('hisasi').textContent, 10) : data.hisasi;
      optionNode.oriage = optionData.querySelector('oriage') ? parseInt(optionData.querySelector('oriage').textContent, 10) : data.oriage;
      optionNode.kesyo_hari = optionData.querySelector('kesyo_hari') ? parseInt(optionData.querySelector('kesyo_hari').textContent, 10) : data.kesyoHari;
      optionNode.makuita = optionData.querySelector('makuita') ? parseInt(optionData.querySelector('makuita').textContent, 10) : data.makuita;
      optionNode.madowaku = optionData.querySelector('madowaku') ? parseInt(optionData.querySelector('madowaku').textContent, 10) : data.madowaku;
      optionNode.balcony_tesuri = optionData.querySelector('balcony_tesuri') ? parseInt(optionData.querySelector('balcony_tesuri').textContent, 10) : data.balconyTesuri;
      optionNode.lighting = optionData.querySelector('lighting') ? parseInt(optionData.querySelector('lighting').textContent, 10) : data.lighting;
      optionNode.suihei_nokiten = optionData.querySelector('suihei_nokiten') ? Boolean(parseInt(optionData.querySelector('suihei_nokiten').textContent, 10)) : data.suihei_nokiten;
      const defaultOptionNode = {
        tuma_kazari: data.tumaKazari,
        flower_box: data.flowerBox,
        desumi_sousyoku: data.desumiSousyoku,
        yoroido: data.yoroido,
        men_gousi: data.menGousi,
        timber: data.timber,
        hisasi: data.hisasi,
        oriage: data.oriage,
        kesyo_hari: data.kesyoHari,
        makuita: data.makuita,
        madowaku: data.madowaku,
        balcony_tesuri: data.balconyTesuri,
        suihei_nokiten: data.suihei_nokiten,
        lighting: data.lighting,
      };
      optionNode = this.jsonNaNCheck(optionNode, defaultOptionNode);
    }
    return optionNode;
  }

  /**
   * 3D modelParam heightxmlデータをjsonに変換します
   * @param heightXml
   * @returns
   */
  static heightXmlToJson(heightXml: any) {
    let heightNode: any = {};
    const heightData = heightXml;
    if (heightData) {
      const data: marietta3d.AutoGen.ConstructionModelHeight = marietta.webcad.WebCADGlobal.autoMain.Model.Height;
      heightNode.slab_level1 = heightData.querySelector('slab_level1') ? parseInt(heightData.querySelector('slab_level1').textContent, 10) : data.slabLevel1;
      heightNode.slab_level2 = heightData.querySelector('slab_level2') ? parseInt(heightData.querySelector('slab_level2').textContent, 10) : data.slabLevel2;
      heightNode.slab_level3 = heightData.querySelector('slab_level3') ? parseInt(heightData.querySelector('slab_level3').textContent, 10) : data.slabLevel3;
      heightNode.slab_level4 = heightData.querySelector('slab_level4') ? parseInt(heightData.querySelector('slab_level4').textContent, 10) : data.slabLevel4;
      heightNode.floor1 = heightData.querySelector('floor1') ? parseInt(heightData.querySelector('floor1').textContent, 10) : data.floor1;
      heightNode.floor2 = heightData.querySelector('floor2') ? parseInt(heightData.querySelector('floor2').textContent, 10) : data.floor2;
      heightNode.floor3 = heightData.querySelector('floor3') ? parseInt(heightData.querySelector('floor3').textContent, 10) : data.floor3;
      heightNode.ceiling1 = heightData.querySelector('ceiling1') ? parseInt(heightData.querySelector('ceiling1').textContent, 10) : data.ceiling1;
      heightNode.ceiling2 = heightData.querySelector('ceiling2') ? parseInt(heightData.querySelector('ceiling2').textContent, 10) : data.ceiling2;
      heightNode.ceiling3 = heightData.querySelector('ceiling3') ? parseInt(heightData.querySelector('ceiling3').textContent, 10) : data.ceiling3;
      heightNode.base_level = heightData.querySelector('base_level') ? parseInt(heightData.querySelector('base_level').textContent, 10) : data.baseLevel;
      heightNode.entrance_level = heightData.querySelector('entrance_level') ? parseInt(heightData.querySelector('entrance_level').textContent, 10) : data.entranceLevel;
      heightNode.porch_level = heightData.querySelector('porch_level') ? parseInt(heightData.querySelector('porch_level').textContent, 10) : data.porchLevel;
      heightNode.out_waist1 = heightData.querySelector('out_waist1') ? parseInt(heightData.querySelector('out_waist1').textContent, 10) : data.outWaist1;
      heightNode.out_waist2 = heightData.querySelector('out_waist2') ? parseInt(heightData.querySelector('out_waist2').textContent, 10) : data.outWaist2;
      heightNode.out_waist3 = heightData.querySelector('out_waist3') ? parseInt(heightData.querySelector('out_waist3').textContent, 10) : data.outWaist3;
      heightNode.handrail_height = heightData.querySelector('handrail_height') ? parseInt(heightData.querySelector('handrail_height').textContent, 10) : data.handrailHeight;
      heightNode.entrance_door_height = heightData.querySelector('entrance_door_height') ? parseInt(heightData.querySelector('entrance_door_height').textContent, 10) : data.entranceDoorHeight;
      heightNode.sasi_height = heightData.querySelector('sasi_height') ? parseInt(heightData.querySelector('sasi_height').textContent, 10) : data.sasiHeight;
      heightNode.door_height = heightData.querySelector('door_height') ? parseInt(heightData.querySelector('door_height').textContent, 10) : data.doorHeight;
      heightNode.falling_wall_height = heightData.querySelector('falling_wall_height') ? parseInt(heightData.querySelector('falling_wall_height').textContent, 10) : data.fallingWallHeight;
      heightNode.habaki_height = heightData.querySelector('habaki_height') ? parseInt(heightData.querySelector('habaki_height').textContent, 10) : data.habakiHeight;
      heightNode.room_waist = heightData.querySelector('room_waist') ? parseInt(heightData.querySelector('room_waist').textContent, 10) : data.roomWaist;
      const defaultHeightNode = {
        slab_level1: data.slabLevel1,
        slab_level2: data.slabLevel2,
        slab_level3: data.slabLevel3,
        slab_level4: data.slabLevel4,
        floor1: data.floor1,
        floor2: data.floor2,
        floor3: data.floor3,
        ceiling1: data.ceiling1,
        ceiling2: data.ceiling2,
        ceiling3: data.ceiling3,
        base_level: data.baseLevel,
        entrance_level: data.entranceLevel,
        porch_level: data.porchLevel,
        out_waist1: data.outWaist1,
        out_waist2: data.outWaist2,
        out_waist3: data.outWaist3,
        handrail_height: data.handrailHeight,
        entrance_door_height: data.entranceDoorHeight,
        sasi_height: data.sasiHeight,
        door_height: data.doorHeight,
        falling_wall_height: data.fallingWallHeight,
        habaki_height: data.habakiHeight,
        room_waist: data.roomWaist,
      };
      heightNode = this.jsonNaNCheck(heightNode, defaultHeightNode);
    }
    return heightNode;
  }

  /**
   * 3D modelParam autoxmlデータをjsonに変換します
   * @param autoXml
   * @returns
   */
  static autoXmlToJson(autoXml: any) {
    const autoNode: any = {};
    const autoData = autoXml;
    if (autoData) {
      const autoRoofData = autoData.querySelector('a_roof');
      if (autoRoofData) {
        let autoRoofNode: any = {};
        const data: marietta3d.AutoGen.ConstructionModelAutoRoof = marietta.webcad.WebCADGlobal.autoMain.Model.AutoRoof;
        const pattr = autoRoofData.attributes;
        autoRoofNode.auto = pattr.getNamedItem('auto').nodeValue ? parseInt(pattr.getNamedItem('auto').nodeValue, 10) : data.auto;
        autoRoofNode.roof_type = pattr.getNamedItem('roof_type').nodeValue ? parseInt(pattr.getNamedItem('roof_type').nodeValue, 10) : data.roofType;
        autoRoofNode.slope = autoRoofData.querySelector('slope') ? parseFloat(autoRoofData.querySelector('slope').textContent) : data.slope;
        autoRoofNode.nokide = autoRoofData.querySelector('nokide') ? parseInt(autoRoofData.querySelector('nokide').textContent, 10) : data.nokide;
        autoRoofNode.tumade = autoRoofData.querySelector('tumade') ? parseInt(autoRoofData.querySelector('tumade').textContent, 10) : data.tumade;
        autoRoofNode.hana_height = autoRoofData.querySelector('hana_height') ? parseInt(autoRoofData.querySelector('hana_height').textContent, 10) : data.hanaHeight;
        autoRoofNode.sumi_width = autoRoofData.querySelector('sumi_width') ? parseInt(autoRoofData.querySelector('sumi_width').textContent, 10) : data.sumiWidth;
        autoRoofNode.sumi_height = autoRoofData.querySelector('sumi_height') ? parseInt(autoRoofData.querySelector('sumi_height').textContent, 10) : data.sumiHeight;
        const defaultAutoNode = {
          auto: data.auto,
          roof_type: data.roofType,
          slope: data.slope,
          nokide: data.nokide,
          tumade: data.tumade,
          hana_height: data.hanaHeight,
          sumi_width: data.sumiWidth,
          sumi_height: data.sumiHeight,
        };
        autoRoofNode = this.jsonNaNCheck(autoRoofNode, defaultAutoNode);
        autoNode.a_roof = autoRoofNode;
      }
      const autotateguData = autoData.querySelector('a_tategu');
      if (autotateguData) {
        const autoTateguNode: any = {};
        const data: marietta3d.AutoGen.SAutoTategu = marietta.webcad.WebCADGlobal.autoMain.Model.AutoTategu;
        autoTateguNode.auto = autotateguData.querySelector('auto') ? (Number.isNaN(Number(autoRoofData.querySelector('auto').textContent)) ? data.auto : parseInt(autoRoofData.querySelector('auto').textContent, 10)) : data.auto;
        autoNode.a_tategu = autoTateguNode;
      }
    }
    return autoNode;
  }

  /**
   *
   * @param jsonData
   * @param defaultData
   * @returns
   */
  static jsonNaNCheck(jsonData, defaultData) {
    Object.keys(jsonData).forEach(key => {
      if (jsonData.hasOwnProperty(key)) {
        if (Number.isNaN(jsonData[key])) {
          jsonData[key] = defaultData.key;
        }
      }
    });
    return jsonData;
  }

  /**
   * 3D modelParam materialxmlデータをjsonに変換します
   * @param materialXml
   * @returns
   */
  static materialXmlToJson(materialXml: any) {
    const materialNode: any = [];
    const materialData = materialXml;
    if (materialData) {
      const out01Node: any = marietta.webcad.util.WebcadJSONParser.outMaterialXmlToJson((materialXml).querySelector('out01'), 'out01');
      const out02Node: any = marietta.webcad.util.WebcadJSONParser.outMaterialXmlToJson((materialXml).querySelector('out02'), 'out02');
      const out03Node: any = marietta.webcad.util.WebcadJSONParser.outMaterialXmlToJson((materialXml).querySelector('out03'), 'out03');
      const interiorNode: any = marietta.webcad.util.WebcadJSONParser.interiorMaterialXmlToJson((materialXml).querySelector('interior'));
      const doorNode: any = marietta.webcad.util.WebcadJSONParser.doorMaterialXmlToJson((materialXml).querySelector('door'));
      const sashNode: any = marietta.webcad.util.WebcadJSONParser.sashMaterialXmlToJson((materialXml).querySelector('sash'));
      const shutterNode: any = marietta.webcad.util.WebcadJSONParser.shutterMaterialXmlToJson((materialXml).querySelector('shutter'));
      const entranceNode: any = marietta.webcad.util.WebcadJSONParser.entranceMaterialXmlToJson((materialXml).querySelector('ent'));
      const room02Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room02'), 'room02');
      const room03Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room03'), 'room03');
      const room04Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room04'), 'room04');
      const room05Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room05'), 'room05');
      const room06Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room06'), 'room06');
      const room07Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room07'), 'room07');
      const room08Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room08'), 'room08');
      const room09Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room09'), 'room09');
      const room10Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room10'), 'room10');
      const room11Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room11'), 'room11');
      const room12Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room12'), 'room12');
      const room13Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room13'), 'room13');
      const room14Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room14'), 'room14');
      const room15Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room15'), 'room15');
      const room16Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room16'), 'room16');
      const room17Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room17'), 'room17');
      const room18Node: any = marietta.webcad.util.WebcadJSONParser.roomMaterialXmlToJson((materialXml).querySelector('room18'), 'room18');
      if (out01Node) materialNode.push(out01Node);
      if (out02Node) materialNode.push(out02Node);
      if (out03Node) materialNode.push(out03Node);
      if (interiorNode) materialNode.push(interiorNode);
      if (doorNode) materialNode.push(doorNode);
      if (sashNode) materialNode.push(sashNode);
      if (shutterNode) materialNode.push(shutterNode);
      if (entranceNode) materialNode.push(entranceNode);
      if (room02Node) materialNode.push(room02Node);
      if (room03Node) materialNode.push(room03Node);
      if (room04Node) materialNode.push(room04Node);
      if (room05Node) materialNode.push(room05Node);
      if (room06Node) materialNode.push(room06Node);
      if (room07Node) materialNode.push(room07Node);
      if (room08Node) materialNode.push(room08Node);
      if (room09Node) materialNode.push(room09Node);
      if (room10Node) materialNode.push(room10Node);
      if (room11Node) materialNode.push(room11Node);
      if (room12Node) materialNode.push(room12Node);
      if (room13Node) materialNode.push(room13Node);
      if (room14Node) materialNode.push(room14Node);
      if (room15Node) materialNode.push(room15Node);
      if (room16Node) materialNode.push(room16Node);
      if (room17Node) materialNode.push(room17Node);
      if (room18Node) materialNode.push(room18Node);
    }
    return materialNode;
  }

  /**
   * 3D modelParam out01, out02, out03xmlデータをjsonに変換します
   * @param outXml
   * @param type
   * @returns
   */
  static outMaterialXmlToJson(outXml: any, type: string) {
    if (outXml) {
      const outData = outXml;
      const outNode: any = {
        name: type,
        list: [],
      };
      let outNodeListData: any = {};
      if (outData.querySelector('mune')) {
        outNodeListData = {
          name: 'mune',
          value: outData.querySelector('mune').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('roof')) {
        outNodeListData = {
          name: 'roof',
          value: outData.querySelector('roof').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('hana')) {
        outNodeListData = {
          name: 'hana',
          value: outData.querySelector('hana').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('tuma')) {
        outNodeListData = {
          name: 'tuma',
          value: outData.querySelector('tuma').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('nokiura')) {
        outNodeListData = {
          name: 'nokiura',
          value: outData.querySelector('nokiura').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('wall')) {
        outNodeListData = {
          name: 'wall',
          value: outData.querySelector('wall').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('kosi')) {
        outNodeListData = {
          name: 'kosi',
          value: outData.querySelector('kosi').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('balcony')) {
        outNodeListData = {
          name: 'balcony',
          value: outData.querySelector('balcony').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('porch')) {
        outNodeListData = {
          name: 'porch',
          value: outData.querySelector('porch').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('base')) {
        outNodeListData = {
          name: 'base',
          value: outData.querySelector('base').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('section')) {
        outNodeListData = {
          name: 'section',
          value: outData.querySelector('section').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('timber')) {
        outNodeListData = {
          name: 'timber',
          value: outData.querySelector('timber').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('makuita')) {
        outNodeListData = {
          name: 'makuita',
          value: outData.querySelector('makuita').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      if (outData.querySelector('madowaku')) {
        outNodeListData = {
          name: 'madowaku',
          value: outData.querySelector('madowaku').textContent,
        };
        outNode.list.push(outNodeListData);
      }
      return outNode;
    }
    return null;
  }

  /**
   *3D modelParam Interior material xmlデータをjsonに変換します
   * @param interiorXml
   * @returns
   */
  static interiorMaterialXmlToJson(interiorXml: any) {
    if (interiorXml) {
      const interiorData = interiorXml;
      const interiorNode: any = {
        name: 'interior',
        list: [],
      };
      let interiorNodeListData: any = {};
      if (interiorData.querySelector('floor')) {
        interiorNodeListData = {
          name: 'floor',
          value: interiorData.querySelector('floor').textContent,
        };
        interiorNode.list.push(interiorNodeListData);
      }
      if (interiorData.querySelector('wall')) {
        interiorNodeListData = {
          name: 'wall',
          value: interiorData.querySelector('wall').textContent,
        };
        interiorNode.list.push(interiorNodeListData);
      }
      if (interiorData.querySelector('kosi')) {
        interiorNodeListData = {
          name: 'kosi',
          value: interiorData.querySelector('kosi').textContent,
        };
        interiorNode.list.push(interiorNodeListData);
      }
      if (interiorData.querySelector('cieling')) {
        interiorNodeListData = {
          name: 'cieling',
          value: interiorData.querySelector('cieling').textContent,
        };
        interiorNode.list.push(interiorNodeListData);
      }
      if (interiorData.querySelector('habaki')) {
        interiorNodeListData = {
          name: 'habaki',
          value: interiorData.querySelector('habaki').textContent,
        };
        interiorNode.list.push(interiorNodeListData);
      }
      return interiorNode;
    }
    return null;
  }

  /**
   *3D modelParam door material xmlデータをjsonに変換します
   * @param doorXml
   * @returns
   */
  static doorMaterialXmlToJson(doorXml: any) {
    if (doorXml) {
      const doorData = doorXml;
      const doorNode: any = {
        name: 'door',
        list: [],
      };
      let doorNodeListData: any = {};
      if (doorData.querySelector('body')) {
        doorNodeListData = {
          name: 'body',
          value: doorData.querySelector('body').textContent,
        };
        doorNode.list.push(doorNodeListData);
      }
      return doorNode;
    }
    return null;
  }

  /**
   *3D modelParam sash xmlデータをjsonに変換します
   * @param sashXml
   * @returns
   */
  static sashMaterialXmlToJson(sashXml: any) {
    if (sashXml) {
      const sashData = sashXml;
      const sashNode: any = {
        name: 'sash',
        list: [],
      };
      let sashNodeListData: any = {};
      if (sashData.querySelector('body')) {
        sashNodeListData = {
          name: 'body',
          value: sashData.querySelector('body').textContent,
        };
        sashNode.list.push(sashNodeListData);
      }
      if (sashData.querySelector('curtain')) {
        sashNodeListData = {
          name: 'curtain',
          value: sashData.querySelector('curtain').textContent,
        };
        sashNode.list.push(sashNodeListData);
      }
      return sashNode;
    }
    return null;
  }

  /**
   *3D modelParam shutter material xmlデータをjsonに変換します
   * @param shutterXml
   * @returns
   */
  static shutterMaterialXmlToJson(shutterXml: any) {
    if (shutterXml) {
      const shutterData = shutterXml;
      const shutterNode: any = {
        name: 'shutter',
        list: [],
      };
      let shutterNodeListData: any = {};
      if (shutterData.querySelector('body')) {
        shutterNodeListData = {
          name: 'body',
          value: shutterData.querySelector('body').textContent,
        };
        shutterNode.list.push(shutterNodeListData);
      }
      return shutterNode;
    }
    return null;
  }

  /**
   *3D modelParam entrance material xmlデータをjsonに変換します
   * @param entranceXml
   * @returns
   */
  static entranceMaterialXmlToJson(entranceXml: any) {
    if (entranceXml) {
      const entranceData = entranceXml;
      const entranceNode: any = {
        name: 'ent',
        list: [],
      };
      let entranceNodeListData: any = {};
      if (entranceData.querySelector('body')) {
        entranceNodeListData = {
          name: 'body',
          value: entranceData.querySelector('body').textContent,
        };
        entranceNode.list.push(entranceNodeListData);
      }
      return entranceNode;
    }
    return null;
  }

  /**
   * 3D modelParam room material xmlデータをjsonに変換します
   * @param roomXml
   * @param type
   * @returns
   */
  static roomMaterialXmlToJson(roomXml: any, type: string) {
    if (roomXml) {
      const roomData = roomXml;
      const roomNode: any = {
        name: type,
        list: [],
      };
      let roomNodeListData: any = {};
      if (roomData.querySelector('ceiling')) {
        roomNodeListData = {
          name: 'ceiling',
          value: roomData.querySelector('ceiling').textContent,
        };
        roomNode.list.push(roomNodeListData);
      }
      if (roomData.querySelector('wall')) {
        roomNodeListData = {
          name: 'wall',
          value: roomData.querySelector('wall').textContent,
        };
        roomNode.list.push(roomNodeListData);
      }
      if (roomData.querySelector('kosi')) {
        roomNodeListData = {
          name: 'kosi',
          value: roomData.querySelector('kosi').textContent,
        };
        roomNode.list.push(roomNodeListData);
      }
      if (roomData.querySelector('habaki')) {
        roomNodeListData = {
          name: 'habaki',
          value: roomData.querySelector('habaki').textContent,
        };
        roomNode.list.push(roomNodeListData);
      }
      if (roomData.querySelector('floor')) {
        roomNodeListData = {
          name: 'floor',
          value: roomData.querySelector('floor').textContent,
        };
        roomNode.list.push(roomNodeListData);
      }
      return roomNode;
    }
    return null;
  }

  /**
   *サイトアイテムのxmlデータをjsonに変換します
   * @param siteXml
   * @returns
   */
  static siteXmlToJson(siteXml: any): any {
    if (siteXml === null) { return; }

    const siteNode: any = {};
    // モード
    siteNode.mode = parseInt(siteXml.getAttribute('mode'), 10);
    // 方位
    siteNode.direction = (parseInt(siteXml.getAttribute('direction'), 10));

    // オブジェクト構造に変更
    const shapeList = siteXml.querySelectorAll('shape');
    siteNode.shape = [];
    for (let i = 0, len = shapeList.length; i < len; i += 1) {
      const itemNode: any = {};
      itemNode.index = parseInt(shapeList[i].getAttribute('index'), 10);
      itemNode.guid = marietta.webcad.WebCADGlobal.getGuid();
      itemNode.color = marietta.webcad.util.WebCADUtil.convertNum10To16(parseInt(shapeList[i].getAttribute('color'), 10));
      const pointList = (shapeList[i]).querySelectorAll('point');
      if (shapeList[i].hasAttribute('base')) {
        itemNode.baseNo = parseInt(shapeList[i].getAttribute('base'), 10);
      }
      let pointObj: marietta.webcad.collection.PointCollection;
      itemNode.point = [];
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseFloat(pointList[j].getAttribute('x'));
        pointObj.y = parseFloat(pointList[j].getAttribute('y'));
        pointObj.road_w = parseInt(pointList[j].getAttribute('road_w'), 10);
        if (Number.isNaN(pointObj.road_w)) pointObj.road_w = 0;
        pointObj.road_lr = Boolean(parseInt(pointList[j].getAttribute('road_lr'), 10));
        pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        itemNode.point.push(pointObj);
      }

      // TODO: convertToAllItems確認用、あとで消す
      itemNode.x = 0;
      itemNode.y = 0;
      siteNode.shape.push(itemNode);
    }
    return siteNode;
  }

  /**
  *階段アイテムのxmlデータをjsonに変換します
  * @param stairXml
  * @returns
  */
  static stairXmlToJson(stairXml: any): any {
    if (stairXml === null) { return; }
    // オブジェクト構造に変更
    const itemIndexList = stairXml.querySelectorAll('item');
    const stairNode: any = [];
    for (let i = 0, len = itemIndexList.length; i < len; i += 1) {
      // アイテム
      const itemNode: any = {};
      itemNode.index = parseInt(itemIndexList[i].getAttribute('index'), 10);
      itemNode.id = itemIndexList[i].getAttribute('id');
      itemNode.guid = marietta.webcad.WebCADGlobal.getGuid();
      itemNode.f = parseInt(itemIndexList[i].getAttribute('f'), 10);
      itemNode.is_reverse = Boolean(parseInt(itemIndexList[i].getAttribute('lr'), 10));
      if (itemIndexList[i].getAttribute('idthreed')) itemNode.idthreed = itemIndexList[i].getAttribute('idthreed');
      itemNode.rotation = parseInt(itemIndexList[i].getAttribute('rotation'), 10);
      itemNode.x = parseFloat(itemIndexList[i].getAttribute('x'));
      itemNode.y = parseFloat(itemIndexList[i].getAttribute('y'));
      itemNode.width = Math.abs(parseInt(itemIndexList[i].getAttribute('width'), 10));
      itemNode.depth = Math.abs(parseInt(itemIndexList[i].getAttribute('depth'), 10));

      // ドット情報
      itemNode.shape = [];
      const pointList = (itemIndexList[i]).querySelectorAll('point');
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].getAttribute('x'), 10);
        pointObj.y = parseInt(pointList[j].getAttribute('y'), 10);
        pointObj.wall_type = parseInt(pointList[j].getAttribute('wall_type'), 10);
        pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        itemNode.shape.push(pointObj);
      }
      stairNode.push(itemNode);
    }
    return stairNode;
  }

  /**
   *部屋アイテムのxmlをjsonに変換します
   * @param roomXml
   * @returns
   */
  static roomXmlToJson(roomXml: any): any {
    if (roomXml === null) { return; }

    // オブジェクト構造に変更
    const roomList = roomXml.querySelectorAll('item');
    const roomNode = [];
    for (let i = 0, len = roomList.length; i < len; i += 1) {
      const itemNode: any = {};
      itemNode.index = parseInt(roomList[i].getAttribute('index'), 10);
      itemNode.id = roomList[i].getAttribute('id');
      itemNode.guid = marietta.webcad.WebCADGlobal.getGuid();
      itemNode.f = parseInt(roomList[i].getAttribute('f'), 10);

      itemNode.color = roomList[i].getAttribute('color');
      itemNode.design_color = roomList[i].getAttribute('design_color');
      itemNode.design_type = roomList[i].getAttribute('design_type');
      // テキスト情報
      const textNode: any = {};
      textNode.x = Number(roomList[i].querySelector('text').getAttribute('x'));
      textNode.y = Number(roomList[i].querySelector('text').getAttribute('y'));
      textNode.area_visible = Number(roomList[i].querySelector('text').getAttribute('area_visible'));
      textNode.ceiling_height_visible = Number(roomList[i].querySelector('text').getAttribute('ceiling_height_visible'));
      textNode.auto_layout = Number(roomList[i].querySelector('text').getAttribute('auto_layout'));
      textNode.area_use_jyou = Number(roomList[i].querySelector('text').getAttribute('area_use_jyou'));
      textNode.visible = Number(roomList[i].querySelector('text').getAttribute('visible'));
      textNode.name = (roomList[i]).querySelector('text').textContent;
      itemNode.text = textNode;
      // シェイプ
      itemNode.shape = [];
      const pointList = (roomList[i]).querySelectorAll('point');
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].getAttribute('x'), 10);
        pointObj.y = parseInt(pointList[j].getAttribute('y'), 10);
        pointObj.wall_type = parseInt(pointList[j].getAttribute('wall_type'), 10);
        pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        itemNode.shape.push(pointObj);
      }
      roomNode.push(itemNode);
    }
    return roomNode;
  }

  /**
   *共通アイテムのxmlからjsonへの変換
   * @param commonXml
   * @returns
   */
  static commonXmlToJson(commonXml: any, type: string): any {
    if (commonXml === null) { return; }
    // オブジェクト構造に変更
    const typeList = commonXml.querySelectorAll('item');
    const typeNode: any = [];
    for (let i = 0, len = typeList.length; i < len; i += 1) {
      const itemNode: any = {};
      itemNode.index = parseInt(typeList[i].getAttribute('index'), 10);
      itemNode.id = typeList[i].getAttribute('id');
      itemNode.guid = marietta.webcad.WebCADGlobal.getGuid();
      itemNode.f = parseInt(typeList[i].getAttribute('f'), 10);
      itemNode.is_reverse = Boolean(parseInt(typeList[i].getAttribute('lr'), 10));
      if (typeList[i].getAttribute('idthreed')) itemNode.idthreed = typeList[i].getAttribute('idthreed');
      itemNode.rotation = parseInt(typeList[i].getAttribute('rotation'), 10);
      itemNode.x = parseFloat(typeList[i].getAttribute('x'));
      itemNode.y = parseFloat(typeList[i].getAttribute('y'));
      if (type === 'fitting') {
        if (typeList[i].getAttribute('use_mm')) itemNode.use_mm = typeList[i].getAttribute('use_mm');
        itemNode.width = parseInt(typeList[i].getAttribute('width'), 10);
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          itemNode.width = parseInt(typeList[i].getAttribute('width_mm'), 10);
        }
        itemNode.width_mm = parseInt(typeList[i].getAttribute('width_mm'), 10);
        itemNode.auto_height = parseInt(typeList[i].getAttribute('auto_height'), 10);
        itemNode.height = parseInt(typeList[i].getAttribute('height'), 10);
        itemNode.z = parseInt(typeList[i].getAttribute('z'), 10);
        itemNode.window_frame = parseInt(typeList[i].getAttribute('window_frame'), 10);
        itemNode.type = typeList[i].getAttribute('type');
      } else {
        itemNode.width = parseInt(typeList[i].getAttribute('width'), 10);
        itemNode.depth = parseInt(typeList[i].getAttribute('depth'), 10);
      }
      typeNode.push(itemNode);
    }
    return typeNode;
  }

  /**
   *屋根アイテムのxmlからjsonへの変換
   * @param roofXml
   * @returns
   */
  static roofXmlToJson(roofXml: any): any {
    if (roofXml === null) { return; }
    const roofNode: any = {};
    // モード
    roofNode.noki_de = parseInt(roofXml.getAttribute('noki_de'), 10);
    // 方位
    roofNode.tsuma_de = (parseInt(roofXml.getAttribute('tsuma_de'), 10));
    // オブジェクト構造に変更
    const roofList = roofXml.querySelectorAll('item');
    roofNode.items = [];
    for (let i = 0, len = roofList.length; i < len; i += 1) {
      const itemNode: any = {};
      itemNode.index = parseInt(roofList[i].getAttribute('index'), 10);
      itemNode.id = roofList[i].getAttribute('id');
      itemNode.guid = marietta.webcad.WebCADGlobal.getGuid();
      itemNode.f = parseInt(roofList[i].getAttribute('f'), 10);
      itemNode.type = parseInt(roofList[i].getAttribute('type'), 10);
      if (itemNode.type === 2) {
        itemNode.direction = parseInt(roofList[i].getAttribute('direction_type'), 10);
      }
      itemNode.shape = [];
      const pointList = (roofList[i]).querySelectorAll('point');
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].getAttribute('x'), 10);
        pointObj.y = parseInt(pointList[j].getAttribute('y'), 10);
        pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        pointObj.type = parseInt(pointList[j].getAttribute('type'), 10);
        itemNode.shape.push(pointObj);
      }
      roofNode.items.push(itemNode);
    }
    return roofNode;
  }

  /**
   * アプリ情報
   * @param appInfo
   *
   */
  static reproduceApplicationInfo(appInfo: any) {
    if (appInfo == null) { return; }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentPlaneVersion = appInfo.version;
  }

  /**
   * プランデータ情報
   * @param planInfo
   *
   */
  static reproducePlanDataInfo(planInfo: any) {
    if (planInfo == null) { return; }
    // 寸法補正（0:フリー寸法 / 1:モジュール補正）を先に確定する。欠落時は既定（フリー寸法）を維持（後方互換）。
    // ※buildingType setter が createPitchList を呼び寸法モードに応じてUI/スナップを設定するため、先に適用しておく。
    marietta.webcad.WebCADGlobal.moduleManager.applyDimensionCorrection(planInfo.dimension_correction);
    if (planInfo.building_type !== null && planInfo.building_type !== undefined) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = planInfo.building_type;
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_HOUSE;
    }
    if (planInfo.module !== null) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch = planInfo.module;
      // モジュール補正選択時に適用するピッチ（アプリ由来値）も保存値で復元しておく。
      // ※modulePitch setter で正規化された値を使う（生値ではなく modulePitch と一致させる）
      marietta.webcad.WebCADGlobal.moduleManager.modulePitchFromApp = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
    }
    if (planInfo.grid !== null) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit = planInfo.grid;
    }
    // 最終的な寸法モードに合わせてモジュールUI（コンボボックス表示・スナップ欄）を同期する
    marietta.webcad.WebCADGlobal.webcad2Dmanager.refreshModuleUiForMode();
    if (planInfo.grade) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.grade = marietta.webcad.WebCADGlobal.masterManager.getGradeInfoById(planInfo.grade);
    }
    if (planInfo.outer_wall_width !== null && planInfo.outer_wall_width !== undefined) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.outerWallThickness = planInfo.outer_wall_width;
    }
  }

  /**
   * model_Paramのパース
   * @param model_paramのエレメント
   */
  static reproduceModelParam(paramNode: any): void {
    if (paramNode) {
      // 2Dのマネージャで保持
      const optionNode = (paramNode).option ? (paramNode).option : null;
      const heightNode = (paramNode).height ? (paramNode).height : null;
      const autoNode: any = (paramNode).auto ? (paramNode).auto : null;
      const materialNode = (paramNode).material ? (paramNode).material : null;
      let modelParam;
      if (heightNode || autoNode || materialNode) {
        marietta.webcad.WebCADGlobal.autoMain.perseModelHeightXML(heightNode);
        marietta.webcad.WebCADGlobal.autoMain.perseModelAutoXML(autoNode);
        modelParam = new marietta.webcad.collection.ModelParamCollection(optionNode, heightNode, autoNode, materialNode);
        marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = modelParam;
      }
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = null;
    }
  }

  /**
   * 敷地
   * */
  static reproduceSiteItem(siteItem: any) {
    if (!siteItem) { return; }

    // モード
    let siteMode: number = parseInt(siteItem.mode, 10);
    // TODO: LayerGroup.tsにgetTypeLayerInFloorLayer()を追加
    const itemLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
    if (Number.isNaN(siteMode as number)) { siteMode = 0; } // 指定されていない場合は簡易モード
    // TODO: itemLayerが取得できたらコメントアウト解除
    itemLayer.mode = siteMode;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode = siteMode;

    // 方位
    marietta.webcad.WebCADGlobal.siteCompass.rotate(parseInt(siteItem.direction, 10));

    // オブジェクト構造に変更
    const siteItemList = siteItem.shape;
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = siteItemList.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(siteItemList[i].index, 10);
      itemInfoList.id = 'sit01_01';
      if (siteItemList[i].guid) {
        itemInfoList.guid = siteItemList[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = 1;
      itemInfoList.color = marietta.webcad.util.WebCADUtil.convertNum10To16(parseInt(siteItemList[i].color, 10));
      if (siteItemList[i].base) {
        itemInfoList.baseNo = parseInt(siteItemList[i].base, 10);
      }
      const pointList = siteItemList[i].point;
      let pointObj: marietta.webcad.collection.PointCollection;
      itemInfoList.dotList = [];
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          pointObj.x = marietta.webcad.util.WebCADUtil.convertMMToPix(parseFloat(pointList[j].x));
          pointObj.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - parseFloat(pointList[j].y));
        } else {
          pointObj.x = parseFloat(pointList[j].x);
          pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseFloat(pointList[j].y);
        }
        pointObj.road_w = parseInt(pointList[j].road_w, 10);
        if (Number.isNaN(pointObj.road_w)) pointObj.road_w = 0;
        pointObj.road_lr = Boolean(parseInt(pointList[j].road_lr, 10));
        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        itemInfoList.dotList.push(pointObj);
      }

      // TODO: convertToAllItems確認用、あとで消す
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemList.push(itemInfoList);
    }

    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
   * 部屋情報一覧
   * */
  static extractRoomInfoList (roomData: any, reverseBoo: Boolean = false):marietta.webcad.collection.ItemInfoCollection[] {
    // オブジェクト構造に変更
    // let itemIndexList = roomData.find('item');
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = roomData.length; i < len; i += 1) {
      // dotList<3のルームアイテムを削除します
      if (roomData[i].shape.length < 3) {
        // eslint-disable-next-line no-continue
        continue;
      }
      // //rom16(階段)は無視する
      // if(roomData[i].getAttribute('id').indexOf('rom16') > -1) continue;

      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = roomData[i].index;
      itemInfoList.id = roomData[i].id;
      itemInfoList.guid = roomData[i].guid;
      if (roomData[i].guid) {
        itemInfoList.guid = roomData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = roomData[i].f;


      if (roomData[i].hasOwnProperty('ceiling_end_item_info')) {
        itemInfoList.ceiling_end_item_info = roomData[i].ceiling_end_item_info;
      }
      if (roomData[i].hasOwnProperty('floor_end_item_info')) {
        itemInfoList.floor_end_item_info = roomData[i].floor_end_item_info;
      }
      if (roomData[i].hasOwnProperty('ceiling_white_item_info')) {
        itemInfoList.ceiling_white_item_info = roomData[i].ceiling_white_item_info;
      }
      if (roomData[i].hasOwnProperty('floor_white_item_info')) {
        itemInfoList.floor_white_item_info = roomData[i].floor_white_item_info;
      }
      if (roomData[i].hasOwnProperty('habaki_height')) {
        itemInfoList.habaki_height = roomData[i].habaki_height;
      }

      itemInfoList.ceiling_documents = roomData[i].ceiling_documents ?? [];
      itemInfoList.floor_documents = roomData[i].floor_documents ?? [];

      // 色情報がない場合idから色情報を逆算
      const itemColor = parseInt(roomData[i].color, 10);
      if (!Number.isNaN(itemColor)) {
        itemInfoList.color = marietta.webcad.util.WebCADUtil.convertNum10To16(itemColor);
      }
      const itemDesignColor = parseInt(roomData[i].design_color, 10);
      if (!Number.isNaN(itemDesignColor)) {
        itemInfoList.designColor = marietta.webcad.util.WebCADUtil.convertNum10To16(itemDesignColor);
      }

      itemInfoList.ceiling_hang_height = (roomData[i].ceiling_hang_height !== undefined) ? roomData[i].ceiling_hang_height : 0;

      const itemDesignType = roomData[i].design_type;
      if (itemDesignType !== null && itemDesignType !== '') {
        const newDesign = marietta.webcad.WebCADGlobal.convertToNewPattern(itemDesignType);
        if (newDesign !== '') {
          itemInfoList.design_type = newDesign;
        } else {
          itemInfoList.design_type = itemDesignType;
        }
      }

      const materialData = roomData[i].material;
      if (materialData != null) {
        itemInfoList.material = {
          ceiling: materialData.ceiling ? materialData.ceiling : null,
          wall: materialData.wall ? materialData.wall : null,
          kosi: materialData.kosi ? materialData.kosi : null,
          habaki: materialData.habaki ? materialData.habaki : null,
          floor: materialData.floor ? materialData.floor : null,
        };
      }

      // テキスト情報
      itemInfoList.text = roomData[i].text.name;
      const itemTextPosition = {
        x: roomData[i].text.x,
        y: roomData[i].text.y,
      };
      if (!Number.isNaN(itemTextPosition.x)) {
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          itemInfoList.textPosition = new marietta.core.Point(
            marietta.webcad.util.WebCADUtil.convertMMToPix(itemTextPosition.x),
            marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - itemTextPosition.y)
          );
        } else {
          itemInfoList.textPosition = new marietta.core.Point(itemTextPosition.x, marietta.webcad.WebCADGlobal.LAYER_SIZE_H - itemTextPosition.y);
        }

        if (reverseBoo) {
          itemInfoList.textPosition.x *= -1;
        }
        itemInfoList.text_visible = Boolean(parseInt(roomData[i].text.visible, 10));
        const areaVisible = parseInt(roomData[i].text.area_visible, 10);
        if (!Number.isNaN(areaVisible)) {
          itemInfoList.text_area_visible = Boolean(areaVisible);
        }

        const ceilingVisible = parseInt(roomData[i].text.ceiling_height_visible, 10);
        if (!Number.isNaN(ceilingVisible)) {
          itemInfoList.text_ceiling_visible = Boolean(ceilingVisible);
        }

        const autoLayout = parseInt(roomData[i].text.auto_layout, 10);
        if (!Number.isNaN(autoLayout)) {
          itemInfoList.auto_layout = Boolean(autoLayout);
        }
        const areaUseJyou = parseInt(roomData[i].text.area_use_jyou, 10);
        if (!Number.isNaN(areaUseJyou)) {
          itemInfoList.area_use_jyou = Boolean(areaUseJyou);
        }
        itemInfoList.text_visible = roomData[i].text.visible;
        itemInfoList.text_area_visible = roomData[i].text.area_visible;
        itemInfoList.auto_layout = roomData[i].text.auto_layout;
        itemInfoList.area_use_jyou = roomData[i].text.area_use_jyou;
      }

      // ドット情報
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemInfoList.dotList = [];
      const pointList = roomData[i].shape;

      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          pointObj.x = marietta.webcad.util.WebCADUtil.convertMMToPix(CalculationUtil.roundValue(pointList[j].x));
          pointObj.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - CalculationUtil.roundValue((pointList[j].y)));
        } else {
          pointObj.x = pointList[j].x;
          // TODO: 反転処理追加
          pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - pointList[j].y;
        }
        pointObj.wall_type = pointList[j].wall_type;
        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        if (pointList[j].material) pointObj.material = pointList[j].material;
        if (pointList[j].inner_end_item_info) pointObj.inner_end_item_info = pointList[j].inner_end_item_info;
        if (pointList[j].outer_end_item_info) pointObj.outer_end_item_info = pointList[j].outer_end_item_info;
        if (pointList[j].habaki_end_item_info) pointObj.habaki_end_item_info = pointList[j].habaki_end_item_info;
        if (pointList[j].inner_white_item_info) pointObj.inner_white_item_info = pointList[j].inner_white_item_info;
        if (pointList[j].outer_white_item_info) pointObj.outer_white_item_info = pointList[j].outer_white_item_info;
        if (pointList[j].habaki_white_item_info) pointObj.habaki_white_item_info = pointList[j].habaki_white_item_info;
        pointObj.wall_documents = pointList[j].wall_documents ?? [];
        pointObj.habaki_documents = pointList[j].habaki_documents ?? [];

        itemInfoList.dotList.push(pointObj);
      }
      // 部屋面積ほぼゼロチェック
      if (marietta.webcad.util.WebCADUtil.isAreaZero(itemInfoList.dotList)) continue;

      itemList.push(itemInfoList);
    }

    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj: any) => obj.index);

    return itemList;
  }
  /**
   * 部屋
   * */
  static reproduceRoomItem(roomData: any, reverseBoo: Boolean = false) {
    if (!roomData) { return; }

    //情報リストの取り出し
    const itemList:ItemInfoCollection[] = WebcadJSONParser.extractRoomInfoList( roomData, reverseBoo );

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
    * 壁
    * @param itemData
    * @returns
    */
  static reproduceWallItem(itemData: any) {
    if (!itemData) { return; }

    // オブジェクト構造に変更
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.id = itemData[i].id;
      if (itemData[i].guid) {
        itemInfoList.guid = itemData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = itemData[i].f;
      itemInfoList.index = itemData[i].index;
      itemInfoList.x = 0;
      itemInfoList.y = 0;

      const pointList = itemData[i].shape;
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();

        pointObj.x = marietta.webcad.util.WebCADUtil.convertMMToPix(pointList[j].x) - itemInfoList.x;
        // TODO: 反転処理追加
        pointObj.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.util.WebCADUtil.convertMMToPix(pointList[j].y) + itemInfoList.y));
        pointObj.wall_type = pointList[j].wall_type;

        if (pointList[j].material) pointObj.material = pointList[j].material;
        if (pointList[j].inner_end_item_info) pointObj.inner_end_item_info = pointList[j].inner_end_item_info;
        if (pointList[j].inner_white_item_info) pointObj.inner_white_item_info = pointList[j].inner_white_item_info;
        if (pointList[j].habaki_end_item_info) pointObj.habaki_end_item_info = pointList[j].habaki_end_item_info;
        if (pointList[j].habaki_white_item_info) pointObj.habaki_white_item_info = pointList[j].habaki_white_item_info;

        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        // pointObj.wall_height = pointList[j].wall_height;
        itemInfoList.dotList.push(pointObj);
      }
      // itemInfoList.validDataCheck('wall');
      itemList.push(itemInfoList);
    }

    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj: any) => obj.index);

    // 生成

    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
   * 部屋情報一覧
   * */
  static extractCommonInfoList (itemData: any, type: string, reverseBoo: Boolean = false):marietta.webcad.collection.ItemInfoCollection[] {
    // オブジェクト構造に変更
    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = itemData[i].index;
      itemInfoList.id = itemData[i].id;
      itemInfoList.guid = itemData[i].guid;
      if (itemData[i].guid) {
        itemInfoList.guid = itemData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = itemData[i].f;
      itemInfoList.lr = itemData[i].is_reverse;
      if (reverseBoo) itemInfoList.lr = !itemInfoList.lr;
      itemInfoList.idthreed = itemData[i].idthreed;
      itemInfoList.rotation = itemData[i].rotation;
      itemInfoList.is_ceiling_item = itemData[i].hasOwnProperty('is_ceiling_item') ? itemData[i].is_ceiling_item : marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(itemData[i].id);
      if (itemData[i].hasOwnProperty('end_item_info')) {
        itemInfoList.end_item_info = itemData[i].end_item_info;
      }
      if (itemData[i].hasOwnProperty('white_item_info')) {
        itemInfoList.white_item_info = itemData[i].white_item_info;
      }
      itemInfoList.documents = itemData[i].documents ?? [];

      if (reverseBoo) {
        if (itemInfoList.rotation === 45) itemInfoList.rotation = 315;
        if (itemInfoList.rotation === 90) itemInfoList.rotation = 270;
        if (itemInfoList.rotation === 135) itemInfoList.rotation = 225;
        if (itemInfoList.rotation === 225) itemInfoList.rotation = 135;
        if (itemInfoList.rotation === 270) itemInfoList.rotation = 90;
        if (itemInfoList.rotation === 315) itemInfoList.rotation = 45;
      }
      if (itemData[i].hasOwnProperty('text')) {
        itemInfoList.text = itemData[i].text;
      } else {
        const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(itemData[i].id);
        itemInfoList.text = item ? (marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10)) : '';
      }
      if (type === 'equipment' || type === 'furniture' || type === 'exterior') {
        itemInfoList.depth = (itemData[i].hasOwnProperty('height')) ? itemData[i].height : 0;
        itemInfoList.width = marietta.webcad.util.WebCADUtil.convertMMToPix(parseInt(itemData[i].width, 10));
        itemInfoList.height = marietta.webcad.util.WebCADUtil.convertMMToPix(parseInt(itemData[i].depth, 10));
      }
      if (type === 'equipment' || type === 'furniture') {
        itemInfoList.x = parseFloat(itemData[i].x);
        itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseFloat(itemData[i].y);
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          itemInfoList.x = marietta.webcad.util.WebCADUtil.convertMMToPix(itemData[i].x);
          itemInfoList.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - itemData[i].y);
        }
      } else {
        // 建具・エクステリア等はmm未満の端数を持つため、切り捨てが起きるparseIntではなくparseFloatで保存値を保持する
        itemInfoList.x = parseFloat(itemData[i].x);
        itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseFloat(itemData[i].y);
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          itemInfoList.x = marietta.webcad.util.WebCADUtil.convertMMToPix(parseFloat(itemData[i].x));
          itemInfoList.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - parseFloat(itemData[i].y));
        }
      }
      if (reverseBoo) itemInfoList.x *= -1;
      itemInfoList.widthmm = Math.abs(parseInt(itemData[i].width, 10));
      itemInfoList.heightmm = Math.abs(parseInt(itemData[i].depth, 10));


      if (type === 'fitting') {
        itemInfoList.width = itemData[i].width;
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          itemInfoList.width = marietta.webcad.util.WebCADUtil.convertMMToPix(itemData[i].width);
        }
        itemInfoList.auto_height = Boolean(parseInt(itemData[i].auto_height, 10));
        itemInfoList.fitting_height = parseInt(itemData[i].height, 10);
        itemInfoList.z = parseInt(itemData[i].z, 10);
        if (itemData[i].material) itemInfoList.material = itemData[i].material;
        if (itemData[i].end_item_info) itemInfoList.end_item_info = itemData[i].end_item_info;
        if (itemData[i].white_item_info) itemInfoList.white_item_info = itemData[i].white_item_info;

        // 既存データの対応建具高さなら、自動高さに変更
        if (itemInfoList.fitting_height === 0) {
          itemInfoList.auto_height = true;
        }
      } else {
        itemInfoList.z = itemData[i].z ? parseInt(itemData[i].z, 10) : 0;
      }
      itemList.push(itemInfoList);
    }

    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj: any) => obj.index);

    return itemList;
  }

  /**
   * 建具・住宅設備・家具・エクステリア
   */
  static reproduceCommonItem(itemData: any, type: string, reverseBoo: Boolean = false) {
    if (!itemData) { return; }

    const itemList:ItemInfoCollection[] = WebcadJSONParser.extractCommonInfoList( itemData, type, reverseBoo );

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      const item = marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
      item.itemInfo.updateArea();
      if (item instanceof marietta.webcad.item.Fitting) {
        item.isCustomRotate = true;
        // 保存された座標・回転を保持したまま、最寄り壁への関連付け（snapWall）のみ復元する
        item.snapToWall(false, false);
      }
      item.setParentRoom();
      // if (itemList[k].hasOwnProperty('end_item_info')) {
      //   item.setToEndItem(itemList[k].end_item_info);
      // }
    }
  }

  /**
   * 階段
   */
  static reproduceStairItem(itemData: any, reverseBoo: Boolean = false) {
    if (!itemData) { return; }

    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(itemData[i].index, 10);
      itemInfoList.id = itemData[i].id;
      if (itemData[i].guid) {
        itemInfoList.guid = itemData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = parseInt(itemData[i].f, 10);
      itemInfoList.lr = itemData[i].is_reverse;
      itemInfoList.idthreed = itemData[i].idthreed;
      if (reverseBoo) itemInfoList.lr = !itemInfoList.lr;
      itemInfoList.rotation = parseInt(itemData[i].rotation, 10);
      if (reverseBoo) {
        if (itemInfoList.rotation === 45) itemInfoList.rotation = 315;
        if (itemInfoList.rotation === 90) itemInfoList.rotation = 270;
        if (itemInfoList.rotation === 135) itemInfoList.rotation = 225;
        if (itemInfoList.rotation === 225) itemInfoList.rotation = 135;
        if (itemInfoList.rotation === 270) itemInfoList.rotation = 90;
        if (itemInfoList.rotation === 315) itemInfoList.rotation = 45;
      }
      itemInfoList.x = Math.round(parseFloat(itemData[i].x));
      if (reverseBoo) itemInfoList.x *= -1;
      itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - Math.round(parseFloat(itemData[i].y));
      itemInfoList.width = Math.abs(parseInt(itemData[i].width, 10));
      itemInfoList.height = Math.abs(parseInt(itemData[i].depth, 10));

      // ドット情報
      itemInfoList.dotList = [];
      const pointList = itemData[i].shape;
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        pointObj.x = parseInt(pointList[j].x, 10);
        pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].y, 10);
        pointObj.wall_type = parseInt(pointList[j].wall_type, 10);
        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        itemInfoList.dotList.push(pointObj);
      }
      itemList.push(itemInfoList);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
   * 屋根
   * */
  static reproduceRoofItem(roof: any) {
    if (!roof) { return; }

    let itemList = [];
    const roofData = roof.items;
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = roofData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = roofData[i].index;
      itemInfoList.id = roofData[i].id;
      if (roofData[i].guid) {
        itemInfoList.guid = roofData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = roofData[i].f;
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemInfoList.roof_type = parseInt(roofData[i].type, 10);
      if (itemInfoList.roof_type === 2) {
        itemInfoList.roof_direction = parseInt(roofData[i].direction, 10);
      }

      itemInfoList.dotList = [];
      const pointList = roofData[i].shape;
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          pointObj.x = marietta.webcad.util.WebCADUtil.convertMMToPix(pointList[j].x);
          pointObj.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - (pointList[j].y));
        } else {
          pointObj.x = parseInt(pointList[j].x, 10);
          pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].y, 10);
        }
        if (itemInfoList.roof_type === 1) {
          pointObj.type = parseInt(pointList[j].type, 10);
        }
        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        itemInfoList.dotList.push(pointObj);
      }

      itemList.push(itemInfoList);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    // 生成
    let hasRoof: boolean = false;
    for (let k = 0; k < itemList.length; k += 1) {
      hasRoof = true;
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }

    // 屋根デザインの取得
    marietta.webcad.WebCADGlobal.itemManager.getAllRoofs();

    // 読込完了監視
    if (hasRoof) {
      marietta.webcad.util.WebcadJSONParser.roofDrawChecker = setInterval(() => marietta.webcad.util.WebcadJSONParser.roofDrawCheckInterval(), 50);
    }
  }

  /**
   * テキストアイテム
   */
  static extractFreeTextItem(itemData: any) {
    if (!itemData) { return; }

    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = itemData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = parseInt(itemData[i].index, 10);
      itemInfoList.id = itemData[i].id;
      if (itemData[i].guid) {
        itemInfoList.guid = itemData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = parseInt(itemData[i].f, 10);
      itemInfoList.rotation = parseInt(itemData[i].rotation, 10);
      itemInfoList.transformMatrix = itemData[i].transformMatrix?itemData[i].transformMatrix:null;
      itemInfoList.x = Math.round(parseFloat(itemData[i].x));
      itemInfoList.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - Math.round(parseFloat(itemData[i].y));
      itemInfoList.z = itemData[i].z ? Math.round(parseFloat(itemData[i].z)) : 0;
      itemInfoList.width = Math.abs(parseInt(itemData[i].width, 10));
      itemInfoList.height = Math.abs(parseInt(itemData[i].height, 10));
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        itemInfoList.x = marietta.webcad.util.WebCADUtil.convertMMToPix(itemData[i].x);
        itemInfoList.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - itemData[i].y);
        itemInfoList.width = Math.abs(parseInt(marietta.webcad.util.WebCADUtil.convertMMToPix(itemData[i].width).toString(), 10));
        itemInfoList.height = Math.abs(parseInt(marietta.webcad.util.WebCADUtil.convertMMToPix(itemData[i].height).toString(), 10));
      }
      itemInfoList.text = itemData[i].text;
      itemInfoList.text_color = itemData[i].text_color;
      itemInfoList.font_size = parseInt(itemData[i].font_size, 10);
      itemInfoList.is_bold = itemData[i].is_bold ? itemData[i].is_bold : false;
      itemInfoList.is_italic = itemData[i].is_italic ? itemData[i].is_italic : false;
      itemInfoList.is_strike_through = itemData[i].is_strike_through ? itemData[i].is_strike_through : false;
      itemInfoList.is_underline = itemData[i].is_underline ? itemData[i].is_underline : false;
      itemInfoList.text_alignment = itemData[i].text_alignment;
      if (itemData[i].link) {
        itemInfoList.link = itemData[i].link;
      }
      if (itemData[i].after_link) {
        itemInfoList.after_link = itemData[i].after_link;
      }
      if (itemData[i].remarks) { // 備考
        itemInfoList.remarks = itemData[i].remarks;
      }
      if (itemData[i].file_id) {
        itemInfoList.file_id = itemData[i].file_id;
      }
      if (itemData[i].pin_id) itemInfoList.pin_id = itemData[i].pin_id;
      if (itemData[i].is_register_img) itemInfoList.is_register_img = itemData[i].is_register_img;
      if (itemData[i].auxiliaryData) {
        itemInfoList.auxiliaryData = itemData[i].auxiliaryData;
      }
      if( itemData[i].intersectItem ){
        itemInfoList.intersectItem = {uid:itemData[i].intersectItem.uid, type:itemData[i].intersectItem.type, linkedAt:itemData[i].intersectItem.linkedAt};
      }

      itemList.push(itemInfoList);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    return itemList;
  }

  /**
   * テキストアイテム
   */
  static reproduceFreeTextItem(itemData: any) {
    if (!itemData) { return; }

    //情報リストの取り出し
    const itemList:ItemInfoCollection[] = WebcadJSONParser.extractFreeTextItem( itemData );

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
   * 画像検知マーク
   */
  static extractMarkItem(itemData: any): ItemInfoCollection[] {
    if (!itemData) { return []; }

    const getNum = (value: number | string): number => {
      return isNaN(value as number) ? parseInt(value as string, 10) : value as number;
    }

    const util = marietta.webcad.util.WebCADUtil;
    let itemList = [];
    for (let i = 0, len = itemData.length; i < len; i += 1) {
      const itemInfo = new marietta.webcad.collection.ItemInfoCollection();
      itemInfo.index =           getNum(itemData[i].index);
      itemInfo.id =              itemData[i].id;
      itemInfo.guid =            (itemData[i].guid) ?? marietta.webcad.WebCADGlobal.getGuid();
      itemInfo.floor =           getNum(itemData[i].f);
      itemInfo.rotation =        getNum(itemData[i].rotation);
      itemInfo.transformMatrix = itemData[i].transformMatrix ? itemData[i].transformMatrix : null;
      itemInfo.x =               Math.round(getNum(itemData[i].x));
      itemInfo.y =               marietta.webcad.WebCADGlobal.LAYER_SIZE_H - Math.round(getNum(itemData[i].y));
      itemInfo.z =               itemData[i].z ? Math.round(getNum(itemData[i].z)) : 0;
      itemInfo.width =           Math.abs(getNum(itemData[i].width));
      itemInfo.height =          Math.abs(getNum(itemData[i].height));
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        itemInfo.x =      util.convertMMToPix(itemData[i].x);
        itemInfo.y =      util.convertMMToPix(util.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - itemData[i].y);
        itemInfo.width =  Math.abs(getNum(util.convertMMToPix(itemData[i].width).toString()));
        itemInfo.height = Math.abs(getNum(util.convertMMToPix(itemData[i].height).toString()));
      }
      if (itemData[i].link) {
        itemInfo.link = itemData[i].link;
      }
      itemInfo.recognizeData = itemData[i].recognizeData;
      itemList.push(itemInfo);
    }
    // 順番の入れ替え
    itemList = _.sortBy(itemList, (obj) => obj.index);

    return itemList;
  }

  /**
   * 画像検知マーク
   */
  static reproduceMarkItem(itemData: MarkItemInterface[]): void {
    if (!itemData) { return; }

    const itemList = WebcadJSONParser.extractMarkItem(itemData);

    // 生成
    for (let k = 0, len3 = itemList.length; k < len3; k += 1) {
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
    }
  }

  /**
 * 屋根
 * */
  static reproduceColumnItem(columnData: any) {
    if (!columnData) { return; }

    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = columnData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = columnData[i].index;
      itemInfoList.id = columnData[i].id;
      if (columnData[i].guid) {
        itemInfoList.guid = columnData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = columnData[i].f;
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemInfoList.dotList = [];
      const pointList = columnData[i].shape;
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          pointObj.x = marietta.webcad.util.WebCADUtil.convertMMToPix(pointList[j].x);
          pointObj.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - (pointList[j].y));
        } else {
          pointObj.x = parseInt(pointList[j].x, 10);
          pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].y, 10);
        }
        if (pointList[j].material) pointObj.material = pointList[j].material;
        if (pointList[j].inner_end_item_info) pointObj.inner_end_item_info = pointList[j].inner_end_item_info;
        if (pointList[j].inner_white_item_info) pointObj.inner_white_item_info = pointList[j].inner_white_item_info;
        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        itemInfoList.dotList.push(pointObj);
      }
      itemList.push(itemInfoList);
    }
    itemList = _.sortBy(itemList, (obj) => obj.index);
    for (let k = 0; k < itemList.length; k += 1) {
      const item = marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
      item.setParentRoom();
    }
  }

  /**
  * 屋根
  * */
  static reproduceBeamItem(beamData: any) {
    if (!beamData) { return; }

    let itemList = [];
    let itemInfoList: marietta.webcad.collection.ItemInfoCollection;
    for (let i = 0, len = beamData.length; i < len; i += 1) {
      itemInfoList = new marietta.webcad.collection.ItemInfoCollection();
      itemInfoList.index = beamData[i].index;
      itemInfoList.id = beamData[i].id;
      if (beamData[i].guid) {
        itemInfoList.guid = beamData[i].guid;
      } else {
        itemInfoList.guid = marietta.webcad.WebCADGlobal.getGuid();
      }
      itemInfoList.floor = beamData[i].f;
      itemInfoList.height = beamData[i].height;
      itemInfoList.x = 0;
      itemInfoList.y = 0;
      itemInfoList.dotList = [];

      if (beamData[i].hasOwnProperty('end_item_info')) {
        itemInfoList.end_item_info = beamData[i].end_item_info;
      }
      if (beamData[i].hasOwnProperty('white_item_info')) {
        itemInfoList.white_item_info = beamData[i].white_item_info;
      }
      if (beamData[i].hasOwnProperty('material')) {
        itemInfoList.material = beamData[i].material;
      }

      itemInfoList.documents = beamData[i].documents ?? [];

      const pointList = beamData[i].shape;
      let pointObj: marietta.webcad.collection.PointCollection;
      for (let j = 0, len2 = pointList.length; j < len2; j += 1) {
        pointObj = new marietta.webcad.collection.PointCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          pointObj.x = marietta.webcad.util.WebCADUtil.convertMMToPix(pointList[j].x);
          pointObj.y = marietta.webcad.util.WebCADUtil.convertMMToPix(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H) - (pointList[j].y));
        } else {
          pointObj.x = parseInt(pointList[j].x, 10);
          pointObj.y = marietta.webcad.WebCADGlobal.LAYER_SIZE_H - parseInt(pointList[j].y, 10);
        }
        if (pointList[j].guid) {
          pointObj.guid = pointList[j].guid;
        } else {
          pointObj.guid = marietta.webcad.WebCADGlobal.getGuid();
        }
        itemInfoList.dotList.push(pointObj);
      }
      itemList.push(itemInfoList);
    }
    itemList = _.sortBy(itemList, (obj) => obj.index);
    for (let k = 0; k < itemList.length; k += 1) {
      const item = marietta.webcad.WebCADGlobal.itemManager.createItem(itemList[k]);
      item.setParentRoom();
    }
  }

  /**
  *
  * */
  static reproduceQuotationData(quotationData: QuotationListCollection[]) {
    if (!quotationData) { return; }
    marietta.webcad.WebCADGlobal.quotationItemList.tableDataQuotation = quotationData.map((data) => data);
  }

  static roofDrawChecker: any;

  /**
   * 屋根の描画チェック
   * @param model_paramのエレメント
   */
  static roofDrawCheckInterval(): void {
    const itemList: any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
    for (let i = 0, len = itemList.length; i < len; i += 1) {
      if (!(itemList[i] as marietta.webcad.item.Roof).hasDrawing()) {
        return;
      }
    }
    clearInterval(marietta.webcad.util.WebcadJSONParser.roofDrawChecker);

    // 中央表示を再度実施する
    marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
  }

  /**
   * 敷地面積を確保する関数
   */
  static keepSiteItem() {
    // レイヤーを保持
    const list: marietta.webcad.item.MonicaObject[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_SITE_NO);
    const infoList: any = [];
    if (list.length > 0) {
      list.forEach((item) => {
        infoList.push(item.itemInfo);
      });
    }

    if (infoList.length > 0) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.siteList = infoList;
    }
  }

  /**
     * 保持している下絵があれば、再生成
     */
  static resetShitae(): void {
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList || marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList.length === 0) return;

    for (let i = 1; i <= marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeInfoList.length; i += 1) {
      const currentFloor: marietta.webcad.layer.FloorShitaeLayer = (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i, true) as marietta.webcad.layer.FloorShitaeLayer);
      // console.log(marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i-1]);
      currentFloor.layer_shitae.defaultItemInfo = Object.assign(currentFloor.layer_shitae.defaultItemInfo, marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeInfoList[i - 1]);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i - 1]) {
        currentFloor.layer_shitae.childList.push(marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i - 1]);
        (currentFloor.layer_shitae.spt.element).append(marietta.webcad.WebCADGlobal.webcad2Dmanager.shitaeList[i - 1].spt.element);
      }
    }
  }
}
